module.exports = __webpack_public_path__ + "img/top-1-3.e9525870.jpg";